import { getContactsCatalog } from 'common/api/v1/contacts';

import {
    FETCH_CONTACTS,
    FETCH_CONTACTS_FAILURE,
    FETCH_CONTACTS_SUCCESS,
} from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(createProjectModalActions[FETCH_CONTACTS]());

    getContactsCatalog()
        .then((response) => {
            dispatch(
                createProjectModalActions[FETCH_CONTACTS_SUCCESS](
                    response.data.data,
                ),
            );
        })
        .catch((error) =>
            dispatch(
                createProjectModalActions[FETCH_CONTACTS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
